// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__T6gEd","question":"styles_question__28Smf","description":"styles_description__1vzR7"};